module.exports = __webpack_public_path__ + "static/img/1.e1268ab.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/19/sp/1.png
// module id = jESj
// module chunks = 0